import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens, primitives } from '../../../assets/tokens'
import { safeDarken } from '../../../utils/color'

export const AppBarStyled = styled.div`
  .appbar-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* Filtros aplicados en la misma línea que los botones (antes con 10 px de margen arriba quedaban más bajos) */
  .selectContainer {
    flex: 1 1 260px;
    margin: 0;
    max-width: 400px;
  }

  .filterButton {
    margin-right: 0; /* el hueco lo da el gap del contenedor: el último botón llega al borde del contenido */
    height: 40px;
    padding: 10px 14px;
    border: 1.5px solid ${primitives.neutral[300]};
    border-radius: 8px;
    box-shadow: none;
    text-transform: none;
    font-weight: 400;
    color: ${primitives.neutral[600]};
    background-color: ${tokens.color.background.default};

    :hover {
      border-color: ${primitives.neutral[400]};
      background-color: ${tokens.color.background.muted};
    }
  }

  .dropdownIndicator {
    padding: 10px;
  }

  .saveButton {
    margin-right: 0; /* el hueco lo da el gap del contenedor: el último botón llega al borde del contenido */
    height: 40px;
    border-radius: 8px;
    text-transform: none;
    font-weight: 400;
    color: ${props => props.theme.textPrimary};
    background-color: ${props => props.theme.primary};

    :hover {
      background-color: ${props => safeDarken(props.theme.primary)};
    }
  }

  .filterButtonDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 16px;

    .clue-wrapper {
      margin-left: 15px;
    }

    button {
      min-width: 145px;
      margin: 0;
    }
  }

  /* Título y total en la misma línea; el total como pastilla neutra */
  .title-with-total {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;

    > div {
      flex: none;
      margin-right: 0;
    }
  }

  #total{
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: ${tokens.color.text.secondary};
    background-color: ${tokens.color.background.light};
    border-radius: 12px;
    padding: 5px 10px;
  }

  hr{
    margin-top:15px;
  }
`

export const InputStyled = styled.div`
  > div > div {
    min-height: 40px;
    font-size: 14px;
    padding: 0 10px;
    border: 1.5px solid ${tokens.color.border.default};
    border-radius: 8px;
    box-shadow: none;
    :hover,
    :active,
    :focus {
      border: 1.5px solid ${props => props.theme.primary || tokens.color.brand.primary};
    }
  }

  [class*='-menu'] {
    min-height: 100px;
    overflow-y: scroll;
    * {
      background-color: white;
    }
  }

  > div > div span {
    background-color: transparent;
  }

  .dropdownIndicator {
    color: ${colors.greyAlpha15};
  }

  /* Filtros aplicados en una sola línea: dos chips con el texto recortado y el resto en «+N» */
  .filters__value-container {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .filters__multi-value {
    flex-shrink: 1;
    min-width: 0;
    max-width: 160px;
  }

  > div > div .filters__value-container .select-more-values {
    flex-shrink: 0;
    margin: 2px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    color: ${tokens.color.text.secondary};
    background-color: ${tokens.color.background.light};
    border-radius: 4px;
    cursor: default;
  }
`

export const ModalStyled = styled.div`
  && {
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    width: 685px;
    outline: none;

    .modal-body {
      background-color: ${colors.white};
      padding: 30px 50px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      outline: none;
      .grid-decoration {
        position: relative;
        ::before {
          content: '-';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -4px;
        }
      }
      label {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
      }

      .button-wrapper {
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 50px;

        span {
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
          text-align: right;
          cursor: pointer;
        }

        button {
          margin-left: 20px;
        }
      }
    }
  }
`
